module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": "",
      "disabled": !_vm.username
    },
    slot: "activator"
  }, [_vm._v("New Proposal")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Make a Proposal")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Proposal Action",
      "items": _vm.actions,
      "item-text": "label",
      "item-value": "id",
      "required": ""
    },
    model: {
      value: (_vm.actionIdx),
      callback: function($$v) {
        _vm.actionIdx = $$v
      },
      expression: "actionIdx"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.actions[_vm.actionIdx].dataLabel,
      "rules": _vm.dataRules,
      "required": ""
    },
    model: {
      value: (_vm.textData),
      callback: function($$v) {
        _vm.textData = $$v
      },
      expression: "textData"
    }
  })], 1)], 1), _vm._v(" "), _c('small', [_vm._v("*indicates required field")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": "",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f10d88f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/CreateProposal.vue
// module id = 260
// module chunks = 1